import React from 'react';
import { Edit } from '@material-ui/icons';
import Price from '../../common/Price';
import TableIconButton from '../../common/table/TableIconButton';

function EditableAmount(props) {
  const {
    cashTransferRequest,
    onEdit,
  } = props;
  const { currency } = cashTransferRequest;
  const { cashtransferrequestapprovalSet: approvalSet, subtype, status } = cashTransferRequest;
  const isInInitialState = subtype === 'POS-CASH' && status === 'VER' && approvalSet.edges.length === 0;
  return (
    <div>
      <Price
        currency={currency}
        decimalPlaces={4}
      >
        {cashTransferRequest.amount}
      </Price>
      {isInInitialState && process.env.DEPLOYMENT_CODE === 'UK' && (
        <TableIconButton
          key={`${cashTransferRequest.id}_edit_amount`}
          tooltip="Edit Transfer Cash Amount"
          iconClass={Edit}
          color="primary"
          onClick={onEdit}
        />
      )}
    </div>
  );
}


export default EditableAmount;
